var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"request-container"},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('modals.patient_profile.profile.request.card_head')))]),_c('request-tabs',{on:{"toggle":_vm.toggleTab}}),_c('div',{staticClass:"tab-content"},[_c('request-tab-content',{attrs:{"physician":{
                    NetworkTab: _vm.isNetworkTabActive,
                    EmailTabs: _vm.isEmailTabActive,
                    HipaaTab: _vm.isHipaaTabActive,
                }},on:{"toggle":_vm.toggleTab,"refresh-record-request":_vm.getPatientRecordRequest}})],1)],1),_c('record-form',{attrs:{"patientRecordRequests":_vm.patientRecordRequests}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }